// src/locales/document-en.ts
export default {
  documents: {
    title: "Document Library",
    searchPlaceholder: "Search documents...",
    uploadDocument: "Upload Document",
    documentDetails: "Document Details",
    editDocument: "Edit Document",
    reviews: "Reviews",
    recentDocuments: "Recent Documents",
    library: "Document Library",
    documentList: "Document List",
    documentReader: "Document Reader",
    noDocuments: "No documents found",
    createFirstDocument: "Create your first document",
    confirmDeleteMessage: "Are you sure you want to delete this document?",
    tagline: "Discover, read, and share documents",
    filter: "Filter Documents",
    sort: "Sort",
    explore: "Explore Library",
    loading: "Loading documents...",
    notFound: "Document not found",
    
    categories: {
      all: "All Documents",
      business: "Business & Finance",
      tech: "Technology",
      education: "Education",
      law: "Legal",
      art: "Literature & Arts"
    },
    
    filters: {
      all: "All",
      free: "Free",
      paid: "Paid",
      rating: "Minimum Rating",
      category: "Category",
      type: "Document Type"
    },
    
    status: {
      published: "Published",
      pendingReview: "Pending Review",
      draft: "Draft",
      rejected: "Rejected",
      all: "All Statuses"
    },
    
    detail: {
      author: "Author",
      publishDate: "Published on",
      views: "views",
      rating: "ratings",
      description: "Description",
      details: "Document Details",
      format: "Format",
      pageCount: "Pages",
      fileSize: "File Size",
      language: "Language",
      uploadDate: "Uploaded on",
      lastUpdate: "Last updated",
      preview: "Preview",
      reviewsAndRatings: "Reviews and Ratings",
      writeReview: "Write your review",
      yourReview: "Your comments about this document...",
      submitReview: "Submit Review",
      authorInfo: "Author Information",
      viewProfile: "View Profile",
      relatedDocuments: "Related Documents",
      price: "Price",
      free: "Free",
      buyNow: "Buy Now",
      readPreview: "Preview",
      favorite: "Favorite",
      share: "Share"
    },
    
    reader: {
      backToDetails: "Back",
      download: "Download",
      print: "Print",
      share: "Share",
      save: "Save",
      tableOfContents: "Table of Contents",
      prevPage: "Previous Page",
      nextPage: "Next Page",
      page: "Page",
      of: "of"
    },
    
    myDocuments: {
      title: "My Documents",
      subtitle: "Manage your uploaded and purchased documents",
      uploadNew: "Upload New Document",
      tabs: {
        uploaded: "Uploaded",
        purchased: "Purchased"
      },
      search: {
        uploaded: "Search your documents...",
        purchased: "Search purchased documents..."
      },
      table: {
        document: "Document",
        status: "Status",
        price: "Price",
        views: "Views",
        downloads: "Downloads",
        createdAt: "Created on",
        actions: "Actions"
      },
      fileInfo: {
        type: "Format",
        size: "Size",
        pages: "pages"
      },
      actions: {
        view: "View",
        edit: "Edit",
        delete: "Delete",
        readNow: "Read Now",
        download: "Download"
      },
      purchaseInfo: {
        purchaseDate: "Purchased on",
        expiryDate: "Expires on"
      },
      emptyStates: {
        uploadedTitle: "No documents yet",
        uploadedDesc: "Start sharing your knowledge by uploading your first document",
        uploadButton: "Upload New Document",
        purchasedTitle: "No purchased documents",
        purchasedDesc: "Explore our document library to find documents that suit your needs",
        exploreButton: "Browse Library"
      },
      pagination: "Showing {{from}}-{{to}} of {{total}} results"
    },
    
    upload: {
      title: "Upload New Document",
      subtitle: "Share knowledge and earn from your documents",
      form: {
        documentTitle: "Document Title",
        titlePlaceholder: "Enter document title",
        titleHelp: "A clear title helps your document become more discoverable",
        description: "Description",
        descriptionPlaceholder: "Provide a detailed description of the document content...",
        descriptionHelp: "A detailed description helps readers understand the content and decide whether to purchase your document",
        category: "Category",
        selectCategory: "Select a category",
        language: "Language",
        tags: "Tags",
        tagsPlaceholder: "Enter tags separated by commas",
        tagsHelp: "Example: marketing, strategy, market analysis, Vietnam",
        pricingSection: "Pricing and Protection",
        pricingModel: "Pricing Model",
        free: "Free",
        paid: "Paid",
        price: "Price (VND)",
        pricePlaceholder: "Enter document price",
        feeInfo: "Platform fee: 20% (you'll receive: {{amount}} VND)",
        upload: {
          title: "Upload Document",
          dragDrop: "Drag and drop file or click to select",
          formats: "Supported formats: PDF, DOCX, PPTX, XLSX",
          maxSize: "Maximum: 100MB",
          selectFile: "Select File",
          selected: "Selected: {{name}} ({{size}} MB)"
        },
        cover: {
          title: "Cover Image",
          upload: "Upload Cover Image",
          sizeTip: "Recommended size: 1200 x 1600 pixels (3:4 ratio)"
        },
        publish: {
          title: "Publishing",
          publishNow: "Publish immediately after approval",
          saveDraft: "Save as draft",
          reviewNote: "Your document will be reviewed before publishing (usually within 24 hours)",
          termsCheck: "I confirm this document does not violate copyright and I agree to the Terms of Service",
          submitButton: "Complete Upload",
          cancelButton: "Cancel",
          processing: "Processing..."
        }
      }
    }
  }
};